import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ATbutton from '@at.govt.nz/buttons';
import AddressAutosuggest from '../../components/AddressAutosuggest/AddressAutosuggest';
import {
  logEventJourneyPlanAddressSelect, logJourneyPlannerEvent, JOURNEY_PLAN_TYPE, JOURNEY_PLANNER_ACTION, JOURNEY_PLANNER_CATEGORIES,
} from '../../services/AnalyticsService';
import JourneyPlannerService from '../../services/JourneyPlannerService';
import JourneyPlanActions from '../../redux/JourneyPlan';
import { ReactComponent as IconSwitchDirections } from '../../assets/svg/switchdirections.svg';
import { getAddressLabel } from '../../services/AddressService';

const LOCATION_ERROR_STRING = '';
class JourneyPlanContainer extends Component {
  constructor() {
    super();
    this.state = {
      originProcessing: false,
      destinationProcessing: false,
    };
  }

  _onOriginDetermined = (data) => {
    const { setOrigin } = this.props;
    this.setState(() => ({ originProcessing: false }));
    if (!data || data.error) {
      setOrigin(LOCATION_ERROR_STRING, null);
      return;
    }
    logEventJourneyPlanAddressSelect(data, JOURNEY_PLAN_TYPE.ORIGIN);
    setOrigin(getAddressLabel(data), data);
  };

  _onDestinationDetermined = (data) => {
    const { setDestination } = this.props;
    this.setState(() => ({ destinationProcessing: false }));
    if (!data || data.error) {
      setDestination(LOCATION_ERROR_STRING, null);
      return;
    }
    logEventJourneyPlanAddressSelect(data, JOURNEY_PLAN_TYPE.DEST);
    setDestination(getAddressLabel(data), data);
  };

  _onOriginSelected = () => this.setState(() => ({ originProcessing: true }));

  _onDestinationSelected = () => this.setState(() => ({ destinationProcessing: true }));

  _isProcessing = () => {
    const { originProcessing, destinationProcessing } = this.state;
    return originProcessing || destinationProcessing;
  };

  _onOriginChange = (newValue) => {
    const { setOrigin, originData } = this.props;
    const updatedOriginData = newValue ? originData : null;
    setOrigin(newValue, updatedOriginData);
  };

  _onDestinationChange = (newValue) => {
    const { setDestination, destinationData } = this.props;
    const updatedDestinationData = newValue ? destinationData : null;
    setDestination(newValue, updatedDestinationData);
  };

  _onJourneyPlanClick = () => {
    const { originData, destinationData } = this.props;

    const journeyPlannerLink = JourneyPlannerService.getJourneyPlannerLink(originData, destinationData);

    if (journeyPlannerLink) {
      logJourneyPlannerEvent(JOURNEY_PLANNER_CATEGORIES.NAVIGATION, JOURNEY_PLANNER_ACTION.SHOW_EXT_PROVIDERS);
      window.location.href = journeyPlannerLink;
    }
  };

  _renderOriginInput = () => {
    const {
      originText,
    } = this.props;
    return (
      <div className="jp-address__input jp-address__input--origin">
        <AddressAutosuggest
          id="jp-address-input-origin"
          storageKey="journeyPlan"
          hasCurrentLocation
          hasFrontSpace
          onTextChange={this._onOriginChange}
          ariaLabel="Starting point"
          value={originText}
          placeholder="Starting point / Wāhi tīmata"
          onAddressSelected={this._onOriginSelected}
          onAddressDetermined={this._onOriginDetermined}
        />
      </div>
    );
  };

  _renderDestInput = () => {
    const {
      destinationText,
    } = this.props;
    return (
      <div className="jp-address__input jp-address__input--destination">
        <AddressAutosuggest
          id="jp-address-input-destination"
          storageKey="journeyPlan"
          hasCurrentLocation
          hasFrontSpace
          onTextChange={this._onDestinationChange}
          ariaLabel="Destination"
          value={destinationText}
          placeholder="Destination / Haerenga"
          onAddressSelected={this._onDestinationSelected}
          onAddressDetermined={this._onDestinationDetermined}
        />
      </div>
    );
  };

  _renderSwapButton = () => {
    const { swapOriginDestination } = this.props;
    return (
      <div className="jp-address__swap jp-swap">
        <div className={`${this._isProcessing() ? ' jp-swap__button--processing' : 'jp-swap__button--active'}`} onClick={swapOriginDestination} onKeyPress={swapOriginDestination} role="button" aria-label="Swap origin and destination" tabIndex={0}>
          <IconSwitchDirections className="jp-swap__icon" role="img" />
        </div>
      </div>
    );
  };

  render() {
    const {
      originData, destinationData,
    } = this.props;

    return (
      <div className="main-content-container">
        <div className="at-flex-grid journey-planner">
          <div className="row">
            <div className="col-xs-offset-1 col-xs-9 col-sm-offset-3 col-sm-6">
              <div className="journey-planner__address jp-address">

                <div className="jp-address__circle jp-circle">
                  <div className="jp-circle__container">
                    <div className="jp-circle__circle jp-circle__circle--origin" />
                    <div className="jp-circle__line" />
                    <div className="jp-circle__circle" />
                  </div>
                </div>
                {this._renderOriginInput()}
                {this._renderDestInput()}
                {this._renderSwapButton()}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-offset-1 col-xs-9 col-sm-offset-3 col-sm-6 submit-button-wrapper">
              <div className="jp-button">
                <ATbutton
                  disabled={!(originData && destinationData)}
                  onClick={this._onJourneyPlanClick}
                  aria-label="Plan my journey"
                  tabIndex={0}
                  backgroundColor="dark"
                  block
                >
                  Plan my journey
                </ATbutton>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

JourneyPlanContainer.defaultProps = {
  originData: null,
  originText: '',
  destinationData: null,
  destinationText: '',
};
JourneyPlanContainer.propTypes = {
  originData: PropTypes.any,
  originText: PropTypes.string,
  destinationData: PropTypes.any,
  destinationText: PropTypes.string,
  setOrigin: PropTypes.func.isRequired,
  setDestination: PropTypes.func.isRequired,
  swapOriginDestination: PropTypes.func.isRequired,
};

const mapStateToProps = ({ journeyPlan }) => ({
  originText: journeyPlan.originText,
  originData: journeyPlan.originData,
  destinationText: journeyPlan.destinationText,
  destinationData: journeyPlan.destinationData,
});
const mapDispatchToProps = dispatch => ({
  setOrigin: (originText, originData) => dispatch(JourneyPlanActions.setOrigin(originText, originData)),
  setDestination: (destinationText, destinationData) => dispatch(JourneyPlanActions.setDestination(destinationText, destinationData)),
  swapOriginDestination: () => dispatch(JourneyPlanActions.swapOriginDestination()),
});

export default connect(mapStateToProps, mapDispatchToProps)(JourneyPlanContainer);
